import pieChart from "./pieChart.component";

const pieChartModule = angular
  .module("app.components.pieChart", [])
  .component("pieChart", pieChart);

export default pieChartModule;



// WEBPACK FOOTER //
// ./src/components/pieChart/pieChart.module.js